import { render, staticRenderFns } from "./EditDeliveries.vue?vue&type=template&id=27411a88&scoped=true"
import script from "./EditDeliveries.vue?vue&type=script&lang=js"
export * from "./EditDeliveries.vue?vue&type=script&lang=js"
import style0 from "./EditDeliveries.vue?vue&type=style&index=0&id=27411a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27411a88",
  null
  
)

export default component.exports